export enum NaturezaPessoa {
    Fisica = 1,
    Juridica = 2
  }
  
  export const NaturezaPessoaLabel = new Map<NaturezaPessoa, string>([
    [NaturezaPessoa.Fisica, "Pessoa Física"],
    [NaturezaPessoa.Juridica, "Pessoa Jurídica"]
  ]);
  